import { MediaGallery } from './MediaGallery';
import { Box, Divider, styled, Tab, Tabs, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import { TabsProps } from '@mui/material/Tabs';
import React, { useState } from 'react';
import { RawFileGallery } from './RawFileGallery';
import { MessagingActionHeader } from '../MessagingActionHeader';
import { Routes } from '@xolv-mybrightlink/common';

export const MEDIA_TAB = 0;
export const RAW_FILE_TAB = 1;
export type FILE_GALLERY_TAB = 0 | 1;

const TabPanel = (props: {
  children?: React.ReactNode;
  tab: FILE_GALLERY_TAB;
  value: FILE_GALLERY_TAB;
}) => {
  const { children, value, tab, ...other } = props;

  return (
    <Box
      role='tabpanel'
      hidden={value !== tab}
      id={`simple-tabpanel-${tab}`}
      aria-labelledby={`simple-tab-${tab}`}
      className='hide-scrollbar'
      sx={{
        height: '100%',
        overflow: 'auto',
      }}
      {...other}
    >
      {value === tab && children}
    </Box>
  );
};

const a11yProps = (tab: FILE_GALLERY_TAB) => {
  return {
    id: `simple-tab-${tab}`,
    'aria-controls': `simple-tabpanel-${tab}`,
  };
};

const StyledTabs = styled(Tabs)<TabsProps>(() => ({
  margin: '0 20px 0 20px',
  fontWeight: 'normal',
  fontSize: 14,
  '& .Mui-selected': {
    fontWeight: 600,
  },
}));

type FileGalleryProps = {
  channelGuid: string;
  standalone?: boolean;
  onClose?: () => void;
};

export const FileGallery = (props: FileGalleryProps) => {
  const { channelGuid, standalone, onClose } = props;
  const intl = useIntl();
  const [tab, setTab] = useState<FILE_GALLERY_TAB>(MEDIA_TAB);
  const onChangeTab = (
    event: React.SyntheticEvent,
    newTab: FILE_GALLERY_TAB,
  ) => {
    setTab(newTab);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <MessagingActionHeader
        standalone={standalone}
        channelGuid={channelGuid}
        titleId='care-team.media'
        onClose={onClose}
        expandRoute={Routes.messages.channel.gallery(channelGuid)}
      />
      <Typography sx={{ fontSize: 14, ml: 5, mt: 5 }}>
        {intl.formatMessage({ id: 'care-team.media' })}
      </Typography>
      <StyledTabs
        value={tab}
        onChange={onChangeTab}
        aria-label='basic tabs example'
        variant='fullWidth'
      >
        <Tab
          label={intl.formatMessage({ id: 'care-team.media.photos-videos' })}
          sx={{ whiteSpace: 'nowrap' }}
          {...a11yProps(MEDIA_TAB)}
        />
        <Tab
          label={intl.formatMessage({ id: 'care-team.media.files' })}
          sx={{ whiteSpace: 'nowrap' }}
          {...a11yProps(RAW_FILE_TAB)}
        />
      </StyledTabs>
      <Divider sx={{ height: 20, borderBottomWidth: 0 }} />
      <TabPanel tab={MEDIA_TAB} value={tab}>
        <MediaGallery channelGuid={channelGuid} standalone={standalone} />
      </TabPanel>
      <TabPanel tab={RAW_FILE_TAB} value={tab}>
        <RawFileGallery channelGuid={channelGuid} standalone={standalone} />
      </TabPanel>
    </Box>
  );
};
